var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.podcasts.length)?_c('div',{staticClass:"more-of-category"},[_c('PodcastList',{key:1,attrs:{"bucket":{
      name: ("More in " + (_vm.category.name)),
      items: _vm.podcasts,
      bucket_type: 'podcasts',
      media_size: 'thumbnail',
    },"display-name":false,"type":"podcast"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fadfe560","hasScoped":true,"transformToRequire":{"svg-component":"src","video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--1-1!./app/src/components/MoreOfCategory.vue
// module id = null
// module chunks = 